module.exports = __webpack_public_path__ + "img/contest-logo-cz.c3ace74b.png";